<script setup lang="ts">
import { computed, type ComputedRef } from "vue";
import { RouterView, useRoute } from "vue-router";

import PageWrapper from "@/common/components/PageWrapper.vue";
import type { LinkTab } from "@/common/types";
import { useGetTrackableProductBatchByIdQuery } from "@/fabricks/batches/api/queries";

definePage({
  meta: {
    auth: ["FabricksAdmin.Access"],
  },
});

const route = useRoute("/fabricks/batches/[batchId]");
const batchId = computed(() => route.params.batchId);

const { data: batch } = useGetTrackableProductBatchByIdQuery(batchId);

const tabs: ComputedRef<LinkTab[]> = computed(() => [
  { title: "Details", to: `/fabricks/batches/${batchId.value}/details` },
  {
    title: "Trackable Products",
    to: `/fabricks/batches/${batchId.value}/trackable-products`,
  },
]);

const breadcrumbLinks = computed(() => [
  {
    label: "Fabricks Batches",
    to: "/fabricks/batches",
  },
  {
    label: batch.value?.description ?? "Batch Details",
    to: "#",
  },
]);
</script>

<template>
  <PageWrapper
    :breadcrumb-links="breadcrumbLinks"
    :tabs="tabs"
    :title="batch?.description"
  >
    <RouterView v-slot="{ Component }">
      <Transition
        mode="out-in"
        name="fade"
      >
        <component :is="Component" />
      </Transition>
    </RouterView>
  </PageWrapper>
</template>
